import axios from "axios";
import {
  Button as Button2,
  DataGrid,
  LoadPanel,
  Template,
} from "devextreme-react";
import AuthFileUploader from "../../../common/AuthFileUploader";
import {
  ColumnChooser,
  ColumnFixing,
  Editing,
  Export,
  FilterRow,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Item,
  Paging,
  Popup,
  Position,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
  Texts,
  Toolbar,
  ToolbarItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { useCallback, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hasPermission } from "../../../../utils/hasPermission";
import { PERM } from "../../../../utils/permissions";
import styled from "styled-components";
import { cat, invPlan, paymentStatus, paytTerm, projectStatus } from "../data";
import AuditTrails from "./AuditTrails";
import Comment from "./Comment";
import ContractInfo from "./ContractInfo";
import GroupCell from "./GroupCell";
import InvoiceNoCell from "./InvoiceNoCell";
import PaymentForm from "./PaymentForm";
import ProjectCompletionDate from "./ProjectCompletionDate";
import ProjectCompletionDateCell from "./ProjectCompletionDateCell";
import { init, updateAll } from "./Redux/payment";

import { off } from "devextreme/events";
import { notifyMsg } from "../../../common/notify";
import AOSPTCBillingTiming from "./AOSPTCBillingTiming";
import "./index.css";

const PaymentStatusGridWrapper = styled.div`
  #paymentStatusGrid {
    max-width: 99vw;
    max-height: 72vh;
    margin: 16px 0px;
  }
`;

const projectStatusDataSource = {
  store: new CustomStore({
    key: "codeId",
    loadMode: "raw",
    load: async () => {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/common/codeList?name=Project Status&cat=13`
      );

      return result.data.code;
    },
  }),
};

export default function PaymentStatus(props) {
  const { handleClickMenu } = props;

  const paymentStatusGridRef = useRef(null);

  const [dataSource, setDataSource] = useState(
    new CustomStore({
      key: ["contrNo", "SEQ"],
      load: async () => {
        // [R3]
        const result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus?div=${userInfo.div}&employeeNo=${userInfo.employeeNo}` // TODO
        );

        return result.data;
      },
      insert: async (values) => {
        // delete values.action;

        axios
          .post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/${values.contrNo}`,
            {
              payt: values,
              employeeNo: userInfo.employeeNo,
            }
          )
          .then(() => {
            notifyMsg("Payment 데이터가 저장되었습니다.", "success");
          });
      },
      update: async (key, values) => {
        delete values.action;
        delete values.updateFields;

        await axios.put(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/${key.contrNo}/${key.SEQ}`,
          {
            payt: values,
            employeeNo: userInfo.employeeNo,
          }
        );
      },
      remove: async (key) => {
        await axios.delete(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/${key.contrNo}/${key.SEQ}`
        );
      },
    })
  );

  // const [projectStatusDataSource, setProjectStatusDataSource] = useState(null);
  // useEffect(async () => {
  //   const result = await axios.get(
  //     `${process.env.REACT_APP_BECCO_API_URL}/api/common/codeList?name=Project Status&cat=13`
  //   );

  //   setProjectStatusDataSource(result.data.code);
  // }, []);

  // const [projectStatusDataSource, setProjectStatusDataSource] = useState(
  //   new CustomStore({
  //     key: "codeId",
  //     load: async () => {
  //       const result = await axios.get(
  //         `${process.env.REACT_APP_BECCO_API_URL}/api/common/codeList?name=Project Status&cat=13`
  //       );

  //       console.debug("projectStatusDataSource", result.data.code);

  //       return result.data.code;
  //     },
  //   })
  // );

  const [paymentPopupVisible, setPaymentPopupVisible] = useState(false);
  const [contractBasicInfo, setContractBasicInfo] = useState(null);
  const [
    projectCompletionDatePopupVisible,
    setProjectCompletionDatePopupVisible,
  ] = useState(false);
  const [contractInfoPopupVisible, setContractInfoPopupVisible] =
    useState(false);
  const [commentPopupVisible, setCommentPopupVisible] = useState(false);
  const [auditTrailsPopupVisible, setAuditTrailsPopupVisible] = useState(false);
  // const [projComplDateChanged, setProjComplDateChanged] = useState(false);
  const [AOSPTCBillingTimingPopupVisible, setAOSPTCBillingTimingPopupVisible] =
    useState(false);
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);

  const userInfo = useSelector((state) => state.userInfo);
  const canEditSales = hasPermission(userInfo.permissions, PERM.SALES_MGMT_EDIT);
  const payment = useSelector((state) => state.payment);
  // const contractBasicInfo = useSelector((state) => state.contractInfo);

  const projectDropDownBoxRef = useRef(null);
  const formPaymentRef = useRef(null);

  const dispatch = useDispatch();

  const contentRender = useCallback(() => {
    return (
      <PaymentForm
        projectDropDownBoxRef={projectDropDownBoxRef}
        formPaymentRef={formPaymentRef}
        payment={payment}
        // projComplDateChanged={projComplDateChanged}
        // setProjComplDateChanged={setProjComplDateChanged}
      />
    );
  }, [payment]);

  const onSaveClick = () => {
    let valid = true;

    if (!payment.contrNo) {
      projectDropDownBoxRef.current.instance.option(
        "validationStatus",
        "invalid"
      );

      valid = false;
    }

    if (valid && formPaymentRef.current.instance.validate().isValid) {
      setPaymentPopupVisible(false);
      // setProjComplDateChanged(false);

      // if (e.changes.length > 0 && e.changes[0].type == "insert") {
      if (payment.action == "insert") {
        paymentStatusGridRef.current.instance
          .getDataSource()
          .store()
          .insert(payment)
          .then(() => {
            paymentStatusGridRef.current.instance.refresh();
          });
      } else {
        const updateValues = {};

        for (const key of payment.updateFields) {
          if (payment.hasOwnProperty(key)) {
            updateValues[key] = payment[key];
          }
        }

        if (updateValues.invPlan != null) {
          updateValues.invPlan = updateValues.invPlan == true ? 1 : 0;
        }

        paymentStatusGridRef.current.instance
          .getDataSource()
          .store()
          .update({ contrNo: payment.contrNo, SEQ: payment.SEQ }, updateValues)
          .then(() => {
            paymentStatusGridRef.current.instance.refresh();
          });
      }

      // setProjComplDateChanged(false);
    }
  };

  const onInitNewRow = () => {
    dispatch(init());
    // setProjComplDateChanged(false);
    setPaymentPopupVisible(true);
  };

  const groupCellRender = (options) => {
    return <GroupCell options={options} handleClickMenu={handleClickMenu} />;
  };

  // const calculateCellValue = (data) => {
  //   return data.AOSQuotNo ? data.AOSQuotNo : data.quotNo;
  // };

  const calculateDisplayValue = (data) => {
    return data.AOSQuotNo ? data.AOSQuotNo : data.quotNo;
  };

  const onClockRotateLeftIconClick = (key) => {
    setContractBasicInfo((prevState) => ({
      ...prevState,
      ...key,
    }));
    // dispatch(updateContractInfo(key));

    setProjectCompletionDatePopupVisible(true);
  };

  const onCircleCheckIconClick = async (data) => {
    axios
      .put(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/reqConfirmProjComplDate/${data.contrNo}/${data.SEQ}`
      )
      .then(() => {
        notifyMsg("[업무 완료 예정일]이 업데이트 되었습니다.", "success");

        paymentStatusGridRef.current.instance.refresh();
      });
  };

  const projComplDateCellRender = (data) => {
    if (!data.value) {
      return;
    }

    return (
      <ProjectCompletionDateCell
        onClockRotateLeftIconClick={onClockRotateLeftIconClick}
        data={data}
        onCircleCheckIconClick={onCircleCheckIconClick}
      />
    );
  };

  const onEditingStart = (e) => {
    dispatch(
      updateAll({
        ...e.data,
        action: "update",
        comment: null,
      })
    );

    setPaymentPopupVisible(true);
  };

  const invNoCellRender = (data) => {
    if (!data.value) {
      return;
    }

    return <InvoiceNoCell data={data} />;
  };

  const onContrInfoIconClick = (e) => {
    setContractBasicInfo((prevState) => ({
      // ...prevState,
      ...e.row.data,
    }));
    // dispatch(updateContractInfo(e.row.data));

    setContractInfoPopupVisible(true);
  };

  const onAuditTrailsIconClick = (e) => {
    setContractBasicInfo((prevState) => ({
      // ...prevState,
      ...e.row.data,
    }));

    setAuditTrailsPopupVisible(true);
  };

  const onCommentIconClick = (e) => {
    setContractBasicInfo((prevState) => ({
      // ...prevState,
      ...e.row.data,
    }));

    setCommentPopupVisible(true);
  };

  const onHiding = (e) => {
    // dispatch(init());/
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#E2EFDA";

      switch (e.column.dataField) {
        case "quotNo":
          e.cellElement.style.backgroundColor = "#BFBFBF";
          break;
        case "paytNo":
        case "paytDescr":
        case "totalContrCost":
        case "costExclVAT":
        case "costInclVAT":
          e.cellElement.style.backgroundColor = "#00B0F0";
          break;
        case "projComplDate":
        case "taskComplDate":
        case "invPlan":
        case "invPlanedDate":
        case "invNo":
        case "invDate":
          e.cellElement.style.backgroundColor = "#FFD966";
          break;
        case "paytTerm":
        case "paytPlanedDate":
        case "paytDate":
          e.cellElement.style.backgroundColor = "#F8CBAD";
          break;
      }
    } else if (e.column.type == "selection") {
      if (e.row && e.row.data.invNo) {
        off(e.cellElement, "dxclick");
      }
    } else if (e.rowType == "data") {
      if (
        e.column.dataField == "projComplDate" ||
        e.column.dataField == "taskComplDate"
      ) {
        if (e.row.data.reqConfirmProjComplDate == "Y") {
          e.cellElement.style.backgroundColor = "#FFE0E0";
        }
      } else if (e.column.dataField == "invNo") {
        if (e.row.data.taskComplDate && e.row.data.invNo == null) {
          e.cellElement.style.backgroundColor = "#FFE0E0";
        }
      }
    }
  };

  const onExporting = (e) => {
    const groupedColumns = e.component
      .getVisibleColumns()
      .filter((c) => c.groupIndex > -1);

    if (groupedColumns.length > 0) {
      notifyMsg("Ungroup All.", "error");

      e.cancel = true;

      return;
    }

    paymentStatusGridRef.current.instance.clearFilter();

    e.component.beginUpdate();
    e.component.columnOption("SEQ", "visible", true);
    e.component.columnOption("cat", "fixed", false);
    e.component.columnOption("quotNo", "fixed", false);
    e.component.columnOption("paytNo", "fixed", false);
    e.component.columnOption("paytDescr", "fixed", false);
    // e.component.columnOption("projStatusCodeId", "groupIndex", null);
    // e.component.columnOption("sprName", "groupIndex", null);
    // e.component.columnOption("contrNo", "groupIndex", null);
    // e.component.clearGrouping();

    const workbook = new Workbook();

    workbook.creator = "BeTree";
    workbook.created = new Date();

    const worksheet = workbook.addWorksheet("Payment Status");

    worksheet.properties.defaultRowHeight = 13.5;

    // worksheet.getCell("A1").dataValidation = {
    //   type: "list",
    //   allowBlank: false,
    //   formulae: ['"PF, AOS, PTC"'],
    // };

    // worksheet.addConditionalFormatting({
    //   ref: `K2:K${worksheet.rowCount}`,
    //   rules: [
    //     {
    //       type: "containsText",
    //       operator: "containsBlanks",
    //       style: {
    //         fill: {
    //           type: "pattern",
    //           pattern: "solid",
    //           bgColor: {
    //             argb: "FFFFF00",
    //           },
    //         },
    //       },
    //     },
    //   ],
    // });

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      // keepColumnWidths: false,
      customizeCell: ({ gridCell, excelCell }) => {
        excelCell.font = {
          size: 10,
        };

        excelCell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        if (gridCell.rowType === "data") {
          switch (gridCell.column.dataField) {
            case "totalContrCost":
            case "costExclVAT":
            case "costInclVAT":
              if (gridCell.value) {
                excelCell.value = parseInt(gridCell.value, 10);
                excelCell.numFmt = "#0,000";
                excelCell.alignment = {
                  vertical: "middle",
                  horizontal: "right",
                };
              }
              break;
            case "paytDescr":
              excelCell.alignment = {
                wrapText: true,
              };
              break;
            case "contrNo":
            case "SEQ":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FBFBFBF" },
              };
              break;
          }
        } else if (gridCell.rowType === "header") {
          excelCell.font = {
            bold: true,
            size: 10,
          };
          excelCell.alignment = {
            vertical: "middle",
            horizontal: "center",
          };

          switch (gridCell.column.dataField) {
            case "quotNo":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FBFBFBF",
                },
              };
              break;
            case "paytNo":
            case "paytDescr":
            case "totalContrCost":
            case "costExclVAT":
            case "costInclVAT":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "F00B0F0",
                },
              };
              break;
            case "projComplDate":
            case "taskComplDate":
            case "invPlan":
            case "invPlanedDate":
            case "invNo":
            case "invDate":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FFFD966",
                },
              };
              break;
            case "paytTerm":
            case "paytPlanedDate":
            case "paytDate":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FF8CBAD",
                },
              };
              break;
            default:
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FE2EFDA",
                },
              };
          }
        }
      },
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], {
            type: "application/octet-stream",
          }),
          "PaymentStatus.xlsx"
        );
      });

      e.component.columnOption("SEQ", "visible", false);
      e.component.columnOption("cat", "fixed", true);
      e.component.columnOption("quotNo", "fixed", true);
      e.component.columnOption("paytNo", "fixed", true);
      e.component.columnOption("paytDescr", "fixed", true);

      // e.component.columnOption("projStatusCodeId", "groupIndex", 1);
      // e.component.columnOption("sprName", "groupIndex", 2);
      // e.component.columnOption("contrNo", "groupIndex", 3);

      e.component.endUpdate();

      notifyMsg("Payment Status 파일이 다운로드 되었습니다.", "success");
    });
  };

  const onUploaded = (e) => {
    setLoadPanelVisible(false);

    notifyMsg("Payment Status 파일이 업로드되었습니다.", "success");

    paymentStatusGridRef.current.instance.refresh();
  };

  const onUploadError = (e) => {
    setLoadPanelVisible(false);

    if (e.error.response) {
      notifyMsg(JSON.parse(e.error.response).message, "error");
    } else {
      notifyMsg("에러가 발생했습니다. 관리자에게 문의해주세요.", "error");
    }
  };

  const onClick = () => {
    setAOSPTCBillingTimingPopupVisible(true);
  };

  const onBellIconClick = async () => {
    const keys = paymentStatusGridRef.current.instance.getSelectedRowKeys();

    if (keys.length > 0) {
      axios
        .put(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/reqConfirmProjComplDate`,
          {
            keys: keys,
            reqConfirmProjComplDate: "Y",
          }
        )
        .then((result) => {
          notifyMsg(
            "실무 부서에게 [업무 완료 예정일]/[업무 완료일]의 업데이트를 요청하였습니다.",
            "success"
          );

          paymentStatusGridRef.current.instance.deselectAll();
        });
    } else {
      notifyMsg(
        "[업무 완료 예정일]/[업무 완료일]을 업데이트 요청하고자 하는 Payment를 선택해주세요.",
        "warning"
      );
    }
  };

  const onEditorPreparing = (e) => {
    if (e.command == "select") {
      if (e.row && e.row.data.invNo) {
        e.editorOptions.disabled = true;
      }
    }
  };

  const onSelectionChanged = (e) => {
    const selectedRowsData = e.selectedRowsData;

    if (selectedRowsData.length > 0) {
      const keys = [];

      selectedRowsData.map((data) => {
        if (data.invNo) {
          keys.push({ contrNo: data.contrNo, SEQ: data.SEQ });
        }
      });

      if (keys.length) {
        e.component.deselectRows(keys);
      }
    }
  };

  const getColumns = useMemo(() => {
    if (canEditSales) {
      return [
        {
          type: "buttons",
          width: 140,
          // allowHiding: false,
          buttons: [
            {
              hint: "Contract Info.",
              icon: "fa-solid fa-circle-info",
              onClick: onContrInfoIconClick,
            },
            {
              hint: "Comments",
              icon: "fa-solid fa-comment",
              onClick: onCommentIconClick,
            },
            {
              name: "edit",
            },
            {
              name: "delete",
              visible: true,
            },
            {
              hint: "Audit Trails",
              name: "auditTrailsButton",
              text: "AT",
              onClick: onAuditTrailsIconClick,
            },
          ],
        },
        {
          dataField: "projStatusCodeId",
          caption: "Project Status",
          dataType: "string",
          // fixed: true,
          lookup: {
            dataSource: projectStatusDataSource,
            displayExpr: "name",
            valueExpr: "codeId",
          },
        },
        {
          dataField: "status",
          caption: "Payment Status",
          dataType: "string",
          // fixed: true,
          lookup: {
            dataSource: paymentStatus,
            displayExpr: "name",
            valueExpr: "id",
          },
        },
        {
          dataField: "sprName",
          caption: "Company Name",
          dataType: "string",
          // fixed: true,
        },
        {
          dataField: "contrNo",
          caption: "Contract No.",
          dataType: "string",
          // fixed: true,
          // groupCellRender: groupCellRender,
        },
        {
          dataField: "SEQ",
          visible: false,
        },
        {
          dataField: "cat",
          caption: "Category",
          dataType: "string",
          // fixed: true,
          lookup: {
            dataSource: cat,
            valueExpr: "id",
            displayExpr: "name",
          },
        },
        {
          dataField: "quotNo",
          caption: "Quotation No.",
          dataType: "string",
          width: 140,
          // fixed: true,
          // calculateCellValue: calculateCellValue,
          calculateDisplayValue: calculateDisplayValue,
        },
        {
          dataField: "AOSQuotNo",
          caption: "AOS Quotation No.",
          dataType: "string",
          width: 140,
          visible: false,
        },
        {
          dataField: "paytNo",
          caption: "Payment No.",
          dataType: "number",
          // fixed: true,
        },
        {
          dataField: "paytDescr",
          caption: "Payment Description",
          dataType: "string",
          width: 200,
          // fixed: true,
        },
        {
          dataField: "totalContrCost",
          caption: "Total Contract Cost (Excl.VAT)",
          dataType: "number",
          format: "#0,000",
        },
        {
          dataField: "costExclVAT",
          caption: "COST (Excl.VAT)",
          dataType: "number",
          format: "#0,000",
        },
        {
          dataField: "costInclVAT",
          caption: "COST (Incl.VAT)",
          dataType: "number",
          format: "#0,000",
        },
        {
          dataField: "projComplDate",
          caption: "업무 완료 예정일",
          dataType: "string",
          width: 150,
          // cellRender: projComplDateCellRender,
          cellTemplate: "projComplDate",
        },
        {
          dataField: "taskComplDate",
          caption: "업무 완료일",
          dataType: "date",
          format: "yyyy-MM-dd",
          minWidth: 150,
        },
        {
          dataField: "invPlan",
          caption: "Invoice Plan",
          lookup: {
            dataSource: invPlan,
            valueExpr: "id",
            displayExpr: "name",
          },
        },
        {
          dataField: "invPlanedDate",
          caption: "Invoice Planed Date",
          dataType: "date",
          format: "yyyy-MM-dd",
        },
        {
          dataField: "invNo",
          caption: "Invoice No.",
          dataType: "string",
          minWidth: 150,
          cellTemplate: "invNo",
        },
        {
          dataField: "invDate",
          caption: "Invoice Date",
          dataType: "date",
          format: "yyyy-MM-dd",
        },
        {
          dataField: "paytTerm",
          caption: "Payment Term",
          dataType: "string",
          lookup: {
            dataSource: paytTerm,
            valueExpr: "id",
            displayExpr: "name",
          },
        },
        {
          dataField: "paytPlanedDate",
          caption: "Payment Planed Date",
          dataType: "date",
          format: "yyyy-MM-dd",
        },
        {
          dataField: "paytDate",
          caption: "Payment Date",
          dataType: "date",
          format: "yyyy-MM-dd",
        },
        {
          dataField: "overdueDate",
          caption: "Overdue Date",
          dataType: "number",
        },
        // {
        //   type: "buttons",
        //   width: 140,
        //   allowHiding: false,
        //   buttons: [
        //     {
        //       hint: "Contract Info.",
        //       icon: "fa-solid fa-circle-info",
        //       onClick: onContrInfoIconClick,
        //     },
        //     {
        //       hint: "Comments",
        //       icon: "fa-solid fa-comment",
        //       onClick: onCommentIconClick,
        //     },
        //     {
        //       name: "edit",
        //     },
        //     {
        //       name: "delete",
        //       visible: true,
        //     },
        //     {
        //       hint: "Audit Trails",
        //       name: "auditTrailsButton",
        //       text: "AT",
        //       onClick: onAuditTrailsIconClick,
        //     },
        //   ],
        // },
      ];
    } else {
      return [
        {
          type: "buttons",
          width: 140,
          // allowHiding: false,
          buttons: [
            {
              hint: "Contract Info.",
              icon: "fa-solid fa-circle-info",
              onClick: onContrInfoIconClick,
            },
            {
              hint: "Comments",
              icon: "fa-solid fa-comment",
              onClick: onCommentIconClick,
            },
            {
              name: "edit",
            },
            // {
            //   name: "delete",
            //   visible: true,
            // },
            // {
            //   hint: "Audit Trails",
            //   name: "auditTrailsButton",
            //   text: "AT",
            //   onClick: onAuditTrailsIconClick,
            // },
          ],
        },
        {
          dataField: "projStatusCodeId",
          caption: "Project Status",
          dataType: "string",
          // fixed: true,
          lookup: {
            dataSource: projectStatusDataSource,
            displayExpr: "name",
            valueExpr: "codeId",
          },
        },
        {
          dataField: "status",
          caption: "Payment Status",
          dataType: "string",
          // fixed: true,
          lookup: {
            dataSource: paymentStatus,
            displayExpr: "name",
            valueExpr: "id",
          },
        },
        {
          dataField: "sprName",
          caption: "Company Name",
          dataType: "string",
          // fixed: true,
        },
        {
          dataField: "contrNo",
          caption: "Contract No.",
          dataType: "string",
          // fixed: true,
          // groupCellRender: groupCellRender,
        },
        {
          dataField: "SEQ",
          visible: false,
        },
        {
          dataField: "cat",
          caption: "Category",
          dataType: "string",
          // fixed: true,
          lookup: {
            dataSource: cat,
            valueExpr: "id",
            displayExpr: "name",
          },
        },
        {
          dataField: "quotNo",
          caption: "Quotation No.",
          dataType: "string",
          width: 140,
          // fixed: true,
          // calculateCellValue: calculateCellValue,
          calculateDisplayValue: calculateDisplayValue,
        },
        {
          dataField: "AOSQuotNo",
          caption: "AOS Quotation No.",
          dataType: "string",
          width: 140,
          visible: false,
        },
        {
          dataField: "paytNo",
          caption: "Payment No.",
          dataType: "number",
          // fixed: true,
        },
        {
          dataField: "paytDescr",
          caption: "Payment Description",
          dataType: "string",
          width: 200,
          // fixed: true,
        },
        {
          dataField: "projComplDate",
          caption: "업무 완료 예정일",
          dataType: "string",
          width: 150,
          // cellRender: projComplDateCellRender,
          cellTemplate: "projComplDate",
        },
        {
          dataField: "taskComplDate",
          caption: "업무 완료일",
          dataType: "date",
          format: "yyyy-MM-dd",
          minWidth: 150,
        },
        {
          dataField: "invPlanedDate",
          caption: "Invoice Planed Date",
          dataType: "date",
          format: "yyyy-MM-dd",
        },
        {
          dataField: "invDate",
          caption: "Invoice Date",
          dataType: "date",
          format: "yyyy-MM-dd",
        },
      ];
    }
  }, []);

  const onHidingLoadPanel = () => {
    setLoadPanelVisible(false);
  };

  const onUploadStarted = (e) => {
    setLoadPanelVisible(true);
  };

  const onClickRefresh = () => {
    //   paymentStatusGridRef.current.instance.getDataSource().reload();
    paymentStatusGridRef.current.instance.refresh();
  };

  return (
    <PaymentStatusGridWrapper>
      {dataSource && (
        <DataGrid
          id="paymentStatusGrid"
          ref={paymentStatusGridRef}
          dataSource={dataSource}
          columns={getColumns}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode="widget"
          rowAlternationEnabled={true}
          showBorders={true}
          showRowLines={true}
          showColumnLines={true}
          width={"100%"}
          height={"100%"}
          repaintChangesOnly={true}
          highlightChanges={true}
          columnAutoWidth={true}
          wordWrapEnabled={true}
          // renderAsync={true}/
          onInitNewRow={onInitNewRow}
          onEditingStart={onEditingStart}
          onCellPrepared={onCellPrepared}
          onExporting={onExporting}
          onEditorPreparing={onEditorPreparing}
          onSelectionChanged={onSelectionChanged}
        >
          <GroupPanel visible={true} />
          <SearchPanel
            visible={true}
            highlightCaseSensitive={true}
            width={240}
          />
          <Grouping autoExpandAll={true} contextMenuEnabled={true} />
          <Scrolling
            mode={"virtual"}
            rowRenderingMode={"virtual"}
            columnRenderingMode={"virtual"}
            showScrollbar={"always"}
          />
          <HeaderFilter visible={true} />
          <FilterRow visible={true} applyFilter={"auto"} />
          <Paging enabled={false} />
          <Sorting mode={"multiple"} />
          {/* <Selection mode={"single"} /> */}
          <Selection
            mode={canEditSales ? "multiple" : "single"}
            showCheckBoxesMode={"always"}
          />
          {/* <ColumnFixing enabled={true} /> */}
          <ColumnChooser height={"340px"} enabled={true} mode={"dragAndDrop"}>
            <Position
              my={"right top"}
              at={"right bottom"}
              of={".dx-datagrid-column-chooser-button"}
            />
          </ColumnChooser>

          <Export enabled={true} />

          <Editing
            refreshMode={"reshape"}
            mode={"popup"}
            allowAdding={true}
            allowUpdating={true}
            allowDeleting={true}
          >
            <Texts
              confirmDeleteMessage={"Are you sure want to delete this payment?"}
            />
            <Popup
              visible={paymentPopupVisible}
              showTitle={true}
              title={
                payment.action == "insert"
                  ? "Create a Payment"
                  : "Edit the Payment"
              }
              height={"auto"}
              showCloseButton={true}
              contentRender={contentRender}
              // onHiding={onHiding}
            >
              {!(!canEditSales && payment.cat == 3) && (
                <ToolbarItem
                  widget={"dxButton"}
                  toolbar={"top"}
                  location={"after"}
                  options={{
                    icon: "save",
                    type: "normal",
                    stylingMode: "contained",
                    onClick: onSaveClick,
                  }}
                />
              )}
            </Popup>
          </Editing>

          <Template name="projComplDate" render={projComplDateCellRender} />
          <Template name="invNo" render={invNoCellRender} />

          <Toolbar>
            {canEditSales && (
              <Item location={"before"}>
                <div className="file-uploader-block">
                  <AuthFileUploader
                    id="paymentStatusFileUploader"
                    width={400}
                    uploadMode="instantly"
                    uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus?employeeNo=${userInfo.employeeNo}`}
                    accept=".xlsx"
                    allowedFileExtensions={[".xlsx"]}
                    showFileList={false}
                    onUploadStarted={onUploadStarted}
                    onUploaded={onUploaded}
                    onUploadError={onUploadError}
                  />
                </div>
              </Item>
            )}
            <Item location={"before"} name={"groupPanel"} />

            <Item location={"after"}>
              <Button2
                text="AOS/PTC 청구시기"
                onClick={onClick}
                stylingMode="contained"
                type="success"
              />
            </Item>
            {canEditSales && (
              <Item location={"after"} name={"addRowButton"} />
            )}
            <Item location={"after"}>
              <Button2 icon="refresh" onClick={onClickRefresh} />
            </Item>
            {canEditSales && (
              <Item location={"after"}>
                <Button2 icon="fa-solid fa-bell" onClick={onBellIconClick} />
              </Item>
            )}
            {canEditSales && <Item name="exportButton" />}
            <Item name="columnChooserButton" />
            <Item name="searchPanel" />
          </Toolbar>
        </DataGrid>
      )}
      {contractBasicInfo && contractBasicInfo.contrNo && (
        <ProjectCompletionDate
          projectCompletionDatePopupVisible={projectCompletionDatePopupVisible}
          setProjectCompletionDatePopupVisible={
            setProjectCompletionDatePopupVisible
          }
          contractBasicInfo={contractBasicInfo}
        />
      )}
      {contractBasicInfo && contractBasicInfo.contrNo && (
        <ContractInfo
          contractInfoPopupVisible={contractInfoPopupVisible}
          setContractInfoPopupVisible={setContractInfoPopupVisible}
          contractBasicInfo={contractBasicInfo}
          projectStatusDataSource={projectStatusDataSource}
          paymentStatusGridRef={paymentStatusGridRef}
        />
      )}
      {contractBasicInfo && contractBasicInfo.contrNo && (
        <Comment
          commentPopupVisible={commentPopupVisible}
          setCommentPopupVisible={setCommentPopupVisible}
          contractBasicInfo={contractBasicInfo}
        />
      )}
      {contractBasicInfo && contractBasicInfo.contrNo && (
        <AuditTrails
          auditTrailsPopupVisible={auditTrailsPopupVisible}
          setAuditTrailsPopupVisible={setAuditTrailsPopupVisible}
          contractBasicInfo={contractBasicInfo}
        />
      )}
      <AOSPTCBillingTiming
        AOSPTCBillingTimingPopupVisible={AOSPTCBillingTimingPopupVisible}
        setAOSPTCBillingTimingPopupVisible={setAOSPTCBillingTimingPopupVisible}
      />
      <LoadPanel
        shadingColor="rgba(0, 0, 0, 0.4)"
        position={{
          of: "#paymentStatusGrid",
        }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        onHiding={onHidingLoadPanel}
      ></LoadPanel>
    </PaymentStatusGridWrapper>
  );
}
